/**
 * @generated SignedSource<<1a404ccbb8482b83c01992d089d7ebc6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyRespLayout_viewer$data = {
  readonly buyPage: {
    readonly appliedFilters: ReadonlyArray<{
      readonly name: string | null;
      readonly values: ReadonlyArray<{
        readonly displayName: string | null;
      } | null> | null;
    } | null> | null;
    readonly bottomModule: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SharedBottomModule_bottomModule">;
    } | null> | null;
    readonly displayMaxNumberOfPages: number | null;
    readonly displayUriRef: string | null;
    readonly filters: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_filters">;
    } | null> | null;
    readonly internalBuyLinks: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_links">;
    } | null> | null;
    readonly totalResults: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_itemSearch" | "BuySharedAsyncModules_buyPage" | "BuySharedBreadcrumbs_buyPage" | "BuySharedDescription_buyPage" | "BuySharedHead_buyPage" | "BuySharedRefetchContainer_buyPage" | "BuySharedRelatedPages_buyPage" | "BuySharedResultContainer_buyPage" | "BuySharedTitle_buyPage" | "SbSharedBillboardAd_itemSearch" | "SharedFollowSearchBanner_itemSearch" | "SharedFollowTopButton_itemSearch" | "SharedRespLinksBlock_itemSearch" | "SharedSaveSearchContext_itemSearch" | "SharedWordpressArticles_itemSearch">;
  } | null;
  readonly isNlgContentEnabled: boolean | null;
  readonly isRelatedBuyPagesEnabled: boolean | null;
  readonly isWordpressArticlesEnabled: boolean | null;
  readonly user?: {
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_user" | "BuySharedAsyncModules_user" | "BuySharedResultContainer_user" | "SharedFollowSearchBanner_user" | "SharedFollowTopButton_user" | "SharedSaveSearchContext_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_viewer" | "BuySharedAsyncModules_viewer" | "BuySharedResultContainer_viewer" | "SharedRespLinksBlock_viewer">;
  readonly " $fragmentType": "BuyRespLayout_viewer";
};
export type BuyRespLayout_viewer$key = {
  readonly " $data"?: BuyRespLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyRespLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "guestId"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin"
    },
    {
      "kind": "RootArgument",
      "name": "numOfItemsToInflate"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "personalizationId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "regions"
    },
    {
      "kind": "RootArgument",
      "name": "rootId"
    },
    {
      "kind": "RootArgument",
      "name": "uriRef"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespLayout_viewer",
  "selections": [
    {
      "alias": "isWordpressArticlesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "WP_EDITORIAL"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
    },
    {
      "alias": "isNlgContentEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NLG_CONTENT"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"NLG_CONTENT\")"
    },
    {
      "alias": "isRelatedBuyPagesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "RELATED_BUY_PAGES"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"RELATED_BUY_PAGES\")"
    },
    {
      "alias": "buyPage",
      "args": [
        {
          "kind": "Variable",
          "name": "buyPageId",
          "variableName": "rootId"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "guestId",
          "variableName": "guestId"
        },
        {
          "kind": "Variable",
          "name": "localeOrigin",
          "variableName": "localeOrigin"
        },
        {
          "kind": "Variable",
          "name": "numOfItemsToInflate",
          "variableName": "numOfItemsToInflate"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "regions",
          "variableName": "regions"
        },
        {
          "kind": "Variable",
          "name": "uriRef",
          "variableName": "uriRef"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "personalizationId"
        }
      ],
      "concreteType": "ItemSearchQueryConnection",
      "kind": "LinkedField",
      "name": "itemSearch",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayMaxNumberOfPages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayUriRef",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParam",
          "kind": "LinkedField",
          "name": "appliedFilters",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchBrowseParsedParamValue",
              "kind": "LinkedField",
              "name": "values",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseFilter",
          "kind": "LinkedField",
          "name": "filters",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BuyRespRefineMenu_filters"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BottomModule",
          "kind": "LinkedField",
          "name": "bottomModule",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedBottomModule_bottomModule"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedRefetchContainer_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedBreadcrumbs_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedTitle_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedRelatedPages_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedResultContainer_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedAsyncModules_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedDescription_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedHead_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedWordpressArticles_itemSearch"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedRespLinksBlock_itemSearch"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedBillboardAd_itemSearch"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalBuyLinkType",
          "kind": "LinkedField",
          "name": "internalBuyLinks",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedRespLinksBlock_links"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuyRespRefineMenu_itemSearch"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedSaveSearchContext_itemSearch"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedFollowTopButton_itemSearch"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedFollowSearchBanner_itemSearch"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedAsyncModules_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedResultContainer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyRespRefineMenu_viewer"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BuyRespRefineMenu_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BuySharedResultContainer_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BuySharedAsyncModules_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedSaveSearchContext_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedFollowTopButton_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedFollowSearchBanner_user"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "568ea7fe8f26ce65f530267161aa6bae";

export default node;
